import { api } from "../api";
import { UserResponseDto } from "./user";

const USER_KEY = "user";

export const authService = {
  async login(
    username: string,
    password: string
  ): Promise<UserResponseDto | null> {
    try {
      const { data } = await api.post<UserResponseDto>(
        "/auth/signin",
        { username, password },
        { withCredentials: true } // http only cookie
      );

      sessionStorage.setItem(USER_KEY, JSON.stringify(data)); // store user in session storage

      return data;
    } catch {
      throw new Error("Login fallito");
    }
  },

  checkLogin(): UserResponseDto | null {
    const raw = sessionStorage.getItem(USER_KEY);
    if (!raw) return null;

    try {
      return JSON.parse(raw) as UserResponseDto;
    } catch {
      throw new Error("Errore nel parsing dei dati utente");
    }
  },

  logout() {
    sessionStorage.removeItem(USER_KEY); // logout from client side
    // api.post("/auth/signout", {}, { withCredentials: true }); // logout from server side
  },
};
